import { Link } from 'react-router'
import { Button } from './ui/button'
import { Icon } from './ui/icon'
import { Logo } from './ui/logo'

export function NotFoundPage({
	title = 'Página no encontrada',
	description = 'Ups! parece que esta página no existe',
}: {
	title?: string
	description?: string
}) {
	return (
		<div
			className="relative flex min-h-screen items-center justify-center bg-cover bg-center bg-no-repeat p-4"
			style={{ backgroundImage: 'url(/img/404.webp)' }}
		>
			<div className="absolute inset-0 bg-white/80" />
			<div className="relative z-10 mx-auto w-full max-w-lg text-center">
				<div className="relative mb-8">
					<div className="absolute inset-0 flex items-center justify-center opacity-5">
						<span className="select-none text-[20rem] font-black leading-none tracking-tighter">404</span>
					</div>

					<div className="relative z-10 py-16">
						<div className="mb-6 inline-flex h-24 w-24 items-center justify-center rounded-full bg-primary">
							<Logo className="h-20 w-20 text-primary" />
						</div>

						<h1
							className="mb-3 text-4xl font-bold tracking-tight text-foreground"
							data-testid="not-found-title"
						>
							{title}
						</h1>
						<p className="mx-auto max-w-sm text-lg text-muted-foreground">{description}</p>
					</div>
				</div>

				<div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
					<Button asChild size="lg" className="w-full sm:w-auto">
						<Link to="/ai">
							<Icon name="home" className="mr-2 h-4 w-4" />
							Ir al inicio
						</Link>
					</Button>
				</div>

				<div className="mt-12 border-t border-border pt-6">
					<p className="text-sm text-muted-foreground">
						<Icon name="scale" className="mr-1 inline h-3 w-3" />
						IUS PRO • Asistente Legal IA
					</p>
				</div>
			</div>
		</div>
	)
}
